export default __webpack_public_path__ + "static/media/Q5_2_resized.3a65c008.jpg";